/**
 * Component: sa-ecosystem-carousel (Developer Platform layout)
 * - Reveal-on-scroll (adds .is-visible)
 * - Plays the media video only while it is on screen
 */
if (!customElements.get('sa-ecosystem-carousel')) {
  class SaEcosystemCarousel extends HTMLElement {
    connectedCallback() {
      this.initReveal();
      this.initVideo();
    }

    initReveal() {
      if (!('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }
      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.classList.add('is-visible');
            obs.disconnect();
          });
        },
        { threshold: 0.15 }
      );
      observer.observe(this);
    }

    initVideo() {
      const video = this.querySelector('video');
      if (!video || !('IntersectionObserver' in window)) return;

      video.muted = true;
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const p = video.play();
              if (p && typeof p.catch === 'function') p.catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.25 }
      );
      observer.observe(video);
    }
  }

  customElements.define('sa-ecosystem-carousel', SaEcosystemCarousel);
}
